<template>
  <div>
    <vue-final-modal
      v-model="showModal"
      classes="modal-container"
      content-class="modal-dialog modal-content"
      :max-width="600"
      :max-height="500"
      :z-index="2000"
    >
      <ElTooltip :content="`Списки покупок`" placement="left">
        <button class="cart_lists" @click="showCartLists">
          <i class="fal fa-clipboard-list"></i>
        </button>
      </ElTooltip>
      <ElTooltip :content="`Сохранить этот список покупок`" placement="left">
        <button
          class="save_cart_list"
          @click="saveCartList"
          :disabled="supplier_list.length == 0"
        >
          <i class="fal fa-save"></i>
        </button>
      </ElTooltip>
      <button class="modal__close" @click="showModal = false">
        <i class="fas fa-times"></i>
      </button>
      <span class="modal__title">
        {{ mode == "list" ? "Список покупок" : "Списки покупок" }}
      </span>
      <div class="modal__content">
        <template v-if="mode == 'list'">
          <div class="tabs">
            <div
              class="tab"
              :class="{ active: tabs.active == 0 }"
              @click="tabs.active = 0"
            >
              Весь список
            </div>
            <div
              class="tab"
              v-for="sup of supplier_list"
              @click="tabs.active = sup.id"
              :class="{ active: tabs.active == sup.id }"
            >
              {{ sup.name }}
            </div>
          </div>
          <template v-if="!tabs.active">
            <div class="emptyList" v-if="supplier_list.length == 0">
              Список пуст
            </div>
            <div class="supplier_items" v-for="sup of supplier_list">
              <div class="supplier_name">{{ sup.name }}</div>
              <div
                class="item"
                v-for="item of cartList.filter((x) => x.supplier_id == sup.id)"
              >
                <button class="remove_item" @click="removeItem(item)">
                  <i class="fal fa-times"></i>
                </button>
                {{ item.name }} {{ item.netto }}
                <quantity
                  class="quantity_holder"
                  type="embed"
                  :quantity="item.amount"
                  @Changed="item.amount = $event"
                />
              </div>
            </div>
          </template>
          <template v-else>
            <div class="supplier_items">
              <div
                class="item"
                v-for="item of cartList.filter(
                  (x) => x.supplier_id == tabs.active
                )"
              >
                <button class="remove_item" @click="removeItem(item)">
                  <i class="fal fa-times"></i>
                </button>
                {{ item.name }}
                <quantity
                  class="quantity_holder"
                  type="embed"
                  :quantity="item.amount"
                  @Changed="item.amount = $event"
                />
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <!-- table of cart list with recovery button  -->
          <div v-for="list of cartLists" :key="'cart_list_id' + list.id">
            <button
              class="recoverList"
              @click="recoverList(list)"
              title="Восстановить"
            >
              <i class="fal fa-share-all"></i>
            </button>
            <b>{{ list.id }} {{ list.name }}</b> ({{
              moment(list.createdAt).format("DD.MM.YYYY HH:mm")
            }})
          </div>
          <div v-if="cartLists.length == 0">
            У Вас ещё нет ни одного списка покупок.
            <br />
            Составьте первый и нажмите сохранить слева.
          </div>
        </template>
      </div>
      <div class="modal__footer" v-if="mode == 'list'">
        <!-- <button class="btn btn-primary" :disabled="supplier_list.length == 0">
          Скачать .PDF
        </button> -->
        <button
          class="btn btn-primary"
          @click="prepareLetter"
          :disabled="supplier_list.length == 0"
        >
          Подготовить {{ supplier_list.length >= 2 ? "письма" : "письмо" }}
        </button>
      </div>
    </vue-final-modal>
    <button class="shoppingBasket" @click="showModal = !showModal">
      <i class="fas fa-shopping-basket"></i>
      <div class="amount" v-if="cartList.length != 0">
        {{ cartList.length }}
      </div>
    </button>
    <letter ref="letterPopup" />
  </div>
</template>

<script>
import apiDriver from "../../../apiDriver";
import quantity from "./_cart_quantity.vue";
import letter from "./letter.vue";
import { Tooltip } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  props: ["cartList", "warehouse", "suppliers"],
  components: {
    quantity,
    letter,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      showModal: false,
      cartLists: [],
      tabs: {
        active: 0,
      },
      mode: "list",
    };
  },
  computed: {
    supplier_list() {
      let list = [];
      for (let item of this.cartList) {
        let supplier = this.suppliers.find((x) => x.id == item.supplier_id);
        let exists = list.find((x) => x.id == item.supplier_id);
        if (supplier && !exists) {
          list.push(supplier);
        }
      }
      return list;
    },
  },
  methods: {
    moment,
    recoverList(list) {
      console.log("recoverList", list);
      this.mode = "list";
      this.$emit("emptyCartList");
      for (let item of list.list) {
        if (item.amount > 0) {
          this.$emit("addItem", item.id, item.amount);
        }
      }
    },
    showCartLists() {
      console.log("showCartLists");
      if (this.mode == "list") {
        this.mode = "lists";
      } else {
        this.mode = "list";
      }
    },
    saveCartList() {
      console.log("saveCartList");
      // swal prompt to give a name to new list
      swal({
        title: "Название нового списка",
        input: "text",
        inputPlaceholder: `Список от ${moment().format("DD.MM.YYYY HH:mm")}`,
        defaultValue: `Список от ${moment().format("DD.MM.YYYY HH:mm")}`,
        showCancelButton: true,
        didOpen: () => {
          const input = swal.getInput();
          input.setSelectionRange(0, input.value.length);
        },
      }).then((result) => {
        console.log("saveCartList swal result", result);
        if (result) {
          apiDriver.services.api
            .post("inventory", "store/cart_list/create", {
              store_id: this.warehouse.id,
              list: this.cartList,
              name: result || undefined,
            })
            .then((response) => {
              this.$toast.success("Список сохранен");
              this.getCartLists();
            });
        }
      });
    },
    getCartLists() {
      apiDriver.services.api
        .get("inventory", "store/cart_list/list", {
          store_id: this.warehouse.id,
        })
        .then((response) => {
          this.cartLists = response.data.list.sort((a, b) => {
            return b.id - a.id;
          });
          console.log("cartLists", this.cartLists);
        });
    },
    prepareLetter() {
      this.$refs.letterPopup.openModal({
        cartList: JSON.parse(JSON.stringify(this.cartList)),
        supplier_list: JSON.parse(JSON.stringify(this.supplier_list)),
        warehouse: this.warehouse,
      });
    },
    removeItem(item) {
      this.$emit("removeItem", item);
      setTimeout(() => {
        let supplier_exists = this.supplier_list.find(
          (x) => x.id == item.supplier_id
        );
        console.log("supplier_exists", supplier_exists);
        if (!supplier_exists) this.tabs.active = 0;
      }, 100);
    },
  },
  mounted() {
    this.getCartLists();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: unset;
  outline: unset;
  border: unset;
  opacity: 0.8;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
}

.modal__footer {
  text-align: right;
  margin-top: 0px;
}

.remove_item {
  border: unset;
  background: unset;
  outline: unset;
  cursor: pointer;
  color: black;
  opacity: 0.6;
  font-size: 10px;
  position: relative;
  &:hover {
    opacity: 1;
    color: red;
  }
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>


<style lang="scss" scoped>
.shoppingBasket {
  position: fixed;
  bottom: 20px;
  right: 20px;
  border-radius: 50px;
  height: 40px;
  width: 40px;
  border: unset;
  background: #3f51b5;
  color: white;
  cursor: pointer;
  outline: none;
  .amount {
    background: red;
    color: white;
    position: absolute;
    top: -6px;
    right: -5px;
    font-weight: bold;
    font-size: 10px;
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 100px;
  }
  &:hover {
    background: #2f3d8d;
  }
  &[disabled] {
    background: #ccc;
    cursor: default;
    .amount {
      display: none;
    }
  }
}

.supplier_name {
  font-weight: bold;
}

.supplier_items {
  margin: 10px 0px;
  .item {
    padding: 2px 0;
    &:hover {
      background: #eee;
    }
  }
  .quantity_holder {
    float: right;
    margin-right: 2px;
  }
}

.emptyList {
  margin: 10px 0px;
  text-align: center;
  color: #999;
}

.tabs {
  border-bottom: 2px solid #eee;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  .tab {
    display: inline-block;
    padding: 5px 10px;
    border-bottom: 2px solid #eee;
    position: relative;
    bottom: -2px;
    cursor: pointer;

    &:hover {
      border-color: #a54ce7;
    }

    &.active {
      border-color: #8a00ef;
    }
  }
}

.cart_lists {
  background: white;
  height: 40px;
  width: 40px;
  position: absolute;
  top: 0px;
  left: -45px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  text-align: center;
  line-height: 36px;
  border: unset;
  outline: unset;
  &:hover {
    color: #3f51b5;
  }
}
.save_cart_list {
  background: white;
  height: 40px;
  width: 40px;
  position: absolute;
  top: 45px;
  left: -45px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  text-align: center;
  line-height: 38px;
  border: unset;
  outline: unset;
  &:hover {
    color: #4caf50;
  }
}

.cart_lists,
.save_cart_list {
  &[disabled] {
    color: #ccc;
    cursor: default;
  }
}

.recoverList {
  border: unset;
  background: unset;
  cursor: pointer;
  opacity: 0.6;
  transform: rotateY(180deg);
  outline: none;
  &:hover {
    opacity: 1;
    color: #3f51b5;
  }
}
</style>


<style lang="scss" scoped>
@media (prefers-color-scheme: dark) {
  .shoppingBasket {
    &[disabled] {
      background: #363636;
      color: #606060;
    }
  }

  ::v-deep .modal-content {
    color: black;
  }
}
</style>